import { MODE_EDIT, MODE_PLAY } from "../../helpers/consts";
import sounds, { SFX } from "../../classes/Sounds";
import Sprite from "../object-graphics/Sprite";
import { TILES } from "../../helpers/tiles";

const BUTTON_OPACITY_FULL = 1;
const BUTTON_OPACITY_DIMMED = 0.2;

export default function EditButton({ level }) {
  if (!level.isEditableByUser) {
    return null;
  }
  const isLevelOver = level.heroDeath || level.isLevelCompleted;

  return (
    <button
      style={{
        opacity: isLevelOver ? BUTTON_OPACITY_DIMMED : BUTTON_OPACITY_FULL,
      }}
      onClick={() => {
        if (isLevelOver) {
          return;
        }
        sounds.playSfx(SFX.CLICK);
        level.setMode(level.isEditMode ? MODE_PLAY : MODE_EDIT);
      }}
    >
      <Sprite
        frameCoord={level.isEditMode ? TILES.RESUME_BUTTON : TILES.EDIT_BUTTON}
      />
    </button>
  );
}
